import { render } from "./PollCard.vue?vue&type=template&id=1a254f40&scoped=true"
import script from "./PollCard.vue?vue&type=script&lang=js"
export * from "./PollCard.vue?vue&type=script&lang=js"

import "./PollCard.vue?vue&type=style&index=0&id=1a254f40&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a254f40"]])

export default __exports__